import { Provider as MoleculesProvider } from "./molecules";
import { Provider as ErrorReportsProvider } from "./errorReports";

export const Provider = ({ children }) => (
    <MoleculesProvider>
        <ErrorReportsProvider>{children}</ErrorReportsProvider>
    </MoleculesProvider>
);
